import request from "@/utils/request.js";

// list
export const GetChatList = function (data) {
  return request.get("/chat/list", data);
};
// add
export const addMessage = function (data) {
  return request.post("/chat/create", data);
};
export const GetChatUser = function (data) {
  return request.get("/chat/getChatUser", data);
};
export const GetChatStyle = function (data) {
  return request.get("/chat/getChatStyle", data);
};
export const GetUserList = function (data) {
	return request.get("/chat/getUserList", data);
  };
export const GetAllNoRedNum = function (data) {
	return request.get('/chat/getAllNoRed', data)
}
export const SetOtherRead = function (data) {
	return request.post('/chat/set-other-read', data)
}
export const FileDownAndToOssAPi = function (data) {
	return request.post('/util/fileBase64ToOss', data)
}
export const SetRecall = function (data) {
	return request.post('/chat/recall', data)
}
export const getQuoteChatList = function (data) {
	return request.get('/chat/getQuoteChatList', data)
}
export const HasChatMessage = function (data) {
	return request.get('/chat/hasMessage', data)
}
export const ClearVisitorUnreadCount = function (data) {
	return request.post('/chat/clear-visitor-unread', data)
}



export const GetMessageList = function (data) {
	return request.get('/message/list', data)
}
export const GetMessageCount = function (data) {
	return request.get('/message/count', data)
}

export const SetMessageRead = function (data) {
	return request.post('/message/set-read', data)
}
export const SetAllMessageRead = function (data) {
	return request.post('/message/set-all-read', data)
}
export const DeleteMessage = function (data) {
	return request.post('/message/delete', data)
}



